import React from 'react'

class Courses extends React.Component {
  handleSingleEvent (event) {
    var acc = document.getElementsByClassName('accordion')
    var i
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active1')
        var panel = this.nextElementSibling
        if (panel.style.display === 'block') {
          panel.style.display = 'none'
        } else {
          panel.style.display = 'block'
        }
      })
    }
  };
  handleEvent (event) {
    var acc = document.getElementsByClassName('accordion')
    var i
    var elem = document.getElementById('ea')
    if (elem.value === 'Expand all') elem.value = 'Collapse all'
    else elem.value = 'Expand all'
    for (i = 0; i < acc.length; i++) {
      acc[i].classList.toggle('active1')
      var panel = acc[i].nextElementSibling
      if (panel.style.display === 'block') {
        panel.style.display = 'none'
      } else {
        panel.style.display = 'block'
      }
    }

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active1')
        var panel = this.nextElementSibling
        if (panel.style.display === 'block') {
          panel.style.display = 'none'
        } else {
          panel.style.display = 'block'
        }
      })
    }
  };

  render () {
    let courseContents, courseSubtitle, subContents
    if (this.props.data !== undefined) {
      courseContents = this.props.data.courseContents
      courseSubtitle = this.props.data.courseSubtitle
      subContents = this.props.data.subContents
    }

    let courseContentsHtml = []
    let subContentsHtml = []
    subContents.forEach(points => {
      let temp = []
      points.forEach(point => {
        temp.push(<li key={point}>{point}</li>)
      })
      subContentsHtml.push(
        <div className='panel'>
          <ul>
            {temp}
          </ul>
        </div>)
    })

    let i = 0
    courseContents.forEach(pyramid => {
      courseContentsHtml.push(
        <button onClick={this.handleSingleEvent} className='accordion'>{pyramid}</button>
      )
      courseContentsHtml.push(subContentsHtml[i])
      i++
    })

    return (
      <section className='our-schedule-area section-padding-100'>

        <div className='container'>

        <div className='row'>
              {/* <!-- Heading --> */}
              <div className='col-12'>
                <div className='section-heading-2 text-center wow fadeInUp' data-wow-delay='300ms'>
                <h4>Course Contents</h4>
                  <p>{courseSubtitle}</p>
                </div>
              </div>
            </div>

          <div className='accordion-option'>
            <button id='ea' onClick={this.handleEvent} className='button1'>Expand all</button>
          </div>

          {courseContentsHtml}

        </div>
      </section>
    )
  }
}

export default Courses
